<div
   [style.height]="'100%'"
   [style.background-color]="(settings$ | async).tagEditBackgroundColor"
   [style.color]="(settings$ | async).tagEditFontColor"
   [class.noTagAvailable]="!(isTagEditable$ | async)"
>
   <!-- left column-->
   <div
      class="tag-info-column sam-padding-left sam-padding-right"
      [class.right-border]="(selectedEditorType$ | async).value !== 'CHECK_BOX'"
      fxLayout="column"
      fxFlex="1 1 auto"
   >
      <!--tag title-->
      <div
         class="tag-id-container"
         fxLayout="row"
         fxFlex="1 0 auto"
         fxFlexAlign="baseline"
         kendoTooltip
         [tooltipTemplate]="tagDescriptionTooltip"
         tooltipClass="tooltip-popup"
         [showOn]="(settings$ | async).showDescriptionTextAsPopover ? 'hover' : 'none'"
         filter="fa-icon, .tag-id"
      >
         <fa-icon
            fxFlexAlign="center"
            *ngIf="(presentationType$ | async)?.showIcon"
            [icon]="(settings$ | async).tagIcon | iconNameToIconDefinition$ | async"
            [fixedWidth]="true"
            [style.color]="(settings$ | async).tagIconColor"
         ></fa-icon>
         <div
            fxFlex="1 1 auto"
            *ngIf="(presentationType$ | async)?.showText"
            class="tag-id sam-padding sam-margin-left"
         >
            {{ tagDisplayName$ | async }}
         </div>
      </div>

      <!--tag description-->
      <div
         class="sam-padding"
         [style.overflow]="'auto'"
         *ngIf="!(settings$ | async).showDescriptionTextAsPopover"
         [innerHTML]="(settings$ | async).descriptionText"
      ></div>
   </div>

   <ng-template #tagDescriptionTooltip let-anchor>
      <div
         [style.max-height]="'300px'"
         [style.max-width]="'450px'"
         [style.overflow]="'auto'"
         [innerHTML]="(settings$ | async).descriptionText"
      ></div>
   </ng-template>

   <!-- main column-->
   <div class="tag-main-column sam-display-contents" fxFlex="1 1 100%">
      <samweb-configurable-editor
         class="sam-full-width sam-full-height sam-form-flex-row"
         [selectedEditorType]="selectedEditorType$ | async"
         [isClearButtonVisible]="isClearButtonVisible$ | async"
         [clearValue]="clearTagValue$ | async"
         [isEditorReadOnly]="isCallTagReadOnly$ | async"
         [editorValue]="callTagValue$ | async"
         [editorSettings]="configurableEditorSettings$ | async"
         (editorValueChanged)="onTagValueChanged($event)"
         (isUpdatingValue)="setIsTyping($event)"
         isInputSafe="true"
         fxFlex="1 1 auto"
      ></samweb-configurable-editor>
   </div>
</div>
